import React from 'react';
import QuoteGrid from "../QuoteGrid";

const QuoteGridNoValidationWrapper = () => {
    return <QuoteGrid/>;
};

export default QuoteGridNoValidationWrapper;
